export default __webpack_public_path__ + "static/media/CA-11 click install app.3ead57c2.png";